import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { editBigExpense } from '../actions';

import { default as Component } from '../components/BigExpenseListItem';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        editBigExpense
    }, dispatch);
}

const Container = compose(
    connect(
        null,
        mapDispatchToProps
    )
)(Component);

export default Container;